import { PiX, PiSparkle, PiChalkboardTeacherBold, PiChatTeardropTextBold } from 'react-icons/pi';
import '../webapp.css';

const TutorialModal = ({ onClose }) => (
  <div className="modal-overlay">
    <div className="modal-box">
      <button className="modal-close-button" onClick={onClose}>
        <PiX />
      </button>
      <div className="tutorial-header">
        <PiSparkle size={32} />
        <h2>Welcome to Kierep!</h2>
        <p>Your all-in-one platform for managing staff, shifts, and more.</p>
      </div>
      <div className="tutorial-content">
        <div className="tutorial-section">
          <h3><PiChalkboardTeacherBold className="tutorial-section-icon" /> Getting Started</h3>
          <ul>
            <li>Each user gets a unique <span className="tutorial-highlight">company code</span> automatically generated.</li>
            <li>Share this code with your frontline staff (best via email).</li>
            <li>Your frontline staff use this code to join your company in the mobile app. Staff should be informed to search for 'Kierep Staff' in the app store for download. </li>
            <li>Once staff join, their information will appear in your <span className="tutorial-highlight">Staff List</span> in the dashboard.</li>
            <li>Use the dashboard to manage shifts, staff, and analyze information with AI.</li>
          </ul>
        </div>
        <div className="tutorial-section">
          <h3><PiChatTeardropTextBold className="tutorial-section-icon" /> AI Features</h3>
          <ul>
            <li>Let <span className="tutorial-highlight">KierepAI</span> analyze your staff and shift data to spot trends and suggest improvements.</li>
            <li>Get instant answers to your questions about scheduling, staff performance, and company metrics.</li>
            <li>Receive smart recommendations for optimizing shift coverage and reducing overtime.</li>
            <li>Use AI-powered feedback and analytics to improve your workflow and decision-making.</li>
          </ul>
        </div>
        <div className="tutorial-section">
          <p className="tutorial-footer-text">Need help? Contact <a href="mailto:ceo@kierep.com" className="tutorial-link">Support</a> anytime.</p>
        </div>
      </div>
    </div>
  </div>
);

export default TutorialModal;
